// extracted by mini-css-extract-plugin
export var inputWrapper = "components-modals-__EditCardNickname-module___inputWrapper";
export var modalActionsWrapper = "components-modals-__EditCardNickname-module___modalActionsWrapper";
export var nickNameInput = "components-modals-__EditCardNickname-module___nickNameInput";